import { cva, VariantProps } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 rounded-xl font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 cursor-pointer",
  {
    variants: {
      variant: {
        primary:
          "bg-primary text-white shadow-[0px_2.77px_2.21px_rgba(0,0,0,0.02)] hover:bg-primary/90",
        secondary:
          "bg-[#f2f7fc] text-[#007aff] border border-[#c4dcf7] shadow-sm hover:bg-gray-50",
        outline: "bg-transparent text-gray-800 border border-gray-300 hover:bg-gray-50",
        ghost: "bg-transparent text-gray-700 hover:bg-transparent hover:text-gray-900",
        danger:
          "bg-red-600 text-white shadow-[0px_2.77px_2.21px_rgba(0,0,0,0.02)] hover:bg-red-700",
      },
      size: {
        sm: "px-3 py-1.5 text-xs",
        md: "px-4 py-2 text-sm",
        icon: "w-10 h-10 p-0",
      },
      fullWidth: {
        true: "w-full",
        false: "",
      },
    },
    defaultVariants: {
      variant: "primary",
      size: "md",
      fullWidth: false,
    },
  },
);

export type ButtonVariant = VariantProps<typeof buttonVariants>["variant"];
export type ButtonSize = VariantProps<typeof buttonVariants>["size"];
